import {
  FaEye,
  FaEdit,
  FaTrash,
  FaStar,
  FaBoxOpen,
} from "react-icons/fa";

import "./ProvisionCard.css";

import getImageUrl from "../../../../../../utils/imageUrl";

function ProvisionCard({
  product,
  onView,
  onEdit,
  onDelete,
}) {

  const imageUrl = product.image
    ? getImageUrl(product.image)
    : "/images/food-placeholder.png";

  return (
    <div className="provision-card">

      <div className="card-image">

        <img
          src={imageUrl}
          alt={product.productName || "Product"}
          onError={(event) => {
            event.currentTarget.src =
              "/images/food-placeholder.png";
          }}
        />

        {product.isFeatured && (
          <span className="featured-badge">
            <FaStar />
            Featured
          </span>
        )}

        {!product.isAvailable && (
          <span className="unavailable-badge">
            Unavailable
          </span>
        )}

      </div>

      <div className="card-content">

        <h3>{product.productName}</h3>

        <p className="brand">
          {product.brand}
        </p>

        <span className="category">
          {product.category}
        </span>

        <div className="price-row">

          <span className="offer-price">
            ₹{product.offerPrice || product.price}
          </span>

          {product.offerPrice &&
            Number(product.offerPrice) <
              Number(product.price) && (
              <span className="actual-price">
                ₹{product.price}
              </span>
            )}

        </div>

        <div className="stock-row">

          <FaBoxOpen />

          <span>
            Stock: {product.stock}
          </span>

          <span className="weight">
            {product.weight} {product.unit}
          </span>

        </div>

        <div className="card-actions">

          <button
            className="view-btn"
            onClick={() => onView(product)}
          >
            <FaEye />
          </button>

          <button
            className="edit-btn"
            onClick={() => onEdit(product)}
          >
            <FaEdit />
          </button>

          <button
            className="delete-btn"
            onClick={() => onDelete(product)}
          >
            <FaTrash />
          </button>

        </div>

      </div>

    </div>
  );
}

export default ProvisionCard;